import Cookies from 'universal-cookie';

const cookies = new Cookies();

export const CCS_URL = process.env.REACT_APP_CCS_URL;

export const headers = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
  'x-api-key': process.env.REACT_APP_CCS_API_KEY
};

/**
 * create an object of headers for calls requiring authorization
 * @returns {object} fetch headers with authorization
 */
export const authHeaders = function authorizationHeadersFactory() {
  const hdrs = {
    ...headers,
    authorization: `Bearer ${cookies.get(process.env.REACT_APP_NAUTH_TOKEN_COOKIE_V1)}`,
    'x-id-token': cookies.get(process.env.REACT_APP_NAUTH_ID_TOKEN_COOKIE)
  };

  if (process.env.NODE_ENV === 'test') {
    hdrs['user-agent'] = 'curl test';
  }

  return hdrs;
};

/**
 * a wrapper for fetch that will throw an error for http status codes above 400
 * @param {string} url - the absolute url of the request
 * @param {object} options - fetch options object
 * @returns {object} jsonResponse
 */
export const betterFetch = async function fetchWithStrictErrors(url, options) {
  const res = await fetch(url, { ...options, mode: 'cors' });
  const jsonResponse = await res.json();
  if (res.status >= 400) {
    const err = new Error(jsonResponse.message);
    err.response = res;
    err.body = jsonResponse;
    throw err;
  }
  return jsonResponse;
};

/**
 * turns an array of filters into a search object for ES querying
 * @param {Array} filters - the search filters
 * @returns {object} search object
 */
export const turnFiltersIntoSearchObj = function turnFiltersIntoSearchObj(filters) {
  const search = {};
  const dateCreated = {};
  filters.forEach(filter => {
    if (filter.k === 'StartDate') {
      dateCreated.k = 'DateCreated';
      dateCreated.v = [filter.v];
    } else if (filter.k === 'EndDate') {
      dateCreated.v.push(filter.v);
      search.dateCreated = dateCreated;
    } else if (search[filter.k]) {
      search[filter.k].push(filter.v);
    } else if (filter.k !== 'DocType') {
      search[filter.k] = [filter.v];
    }
  });
  return search;
};
